module.exports = __webpack_public_path__ + "static/img/brees-2020-slide-7.ac4ff7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2020-slide-7.jpg
// module id = IIuG
// module chunks = 1